"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InputField = _interopRequireDefault(require("../InputField"));

var _LoadingIndicator = _interopRequireDefault(require("../LoadingIndicator"));

var _stylingUtils = require("../../services/stylingUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ResultsDialog = function ResultsDialog(_ref) {
  var children = _ref.children,
      show = _ref.show;
  if (!show) return null;
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: "rhe-typeahead__results"
  }, children);
};

var _timeoutID;
/*
See documentation for method of controlling focus/blur for parent container elements
https://medium.com/@jessebeach/dealing-with-focus-and-blur-in-a-composite-widget-in-react-90d3c3b49a9b
*/


var Typeahead = /*#__PURE__*/function (_React$Component) {
  _inherits(Typeahead, _React$Component);

  var _super = _createSuper(Typeahead);

  function Typeahead() {
    var _this;

    _classCallCheck(this, Typeahead);

    _this = _super.call(this);
    _this.state = {
      hasFocus: false
    };
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onKeyDown = _this._onKeyDown.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Typeahead, [{
    key: "_getClassName",
    value: function _getClassName() {
      return (0, _stylingUtils.getClassNames)(this.props.className, {
        'rhe-typeahead': true
      });
    }
  }, {
    key: "_onBlur",
    value: function _onBlur() {
      var _this2 = this;

      _timeoutID = setTimeout(function () {
        if (_this2.state.hasFocus) {
          _this2.setState({
            hasFocus: false
          });
        }
      }, 0);
    }
  }, {
    key: "_onFocus",
    value: function _onFocus() {
      clearTimeout(_timeoutID);

      if (!this.state.hasFocus) {
        this.setState({
          hasFocus: true
        });
      }
    }
  }, {
    key: "_onKeyDown",
    value: function _onKeyDown(e) {
      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        e.preventDefault();
      }

      if (e.key === 'ArrowDown' && e.target.classList.contains('rhe-input')) {
        e.target.closest('.rhe-typeahead').querySelector('.rhe-typeahead-result').focus();
      }

      if (e.key === 'ArrowUp' && e.target.previousElementSibling) {
        e.target.previousElementSibling.focus();
      }

      if (e.key === 'ArrowDown' && e.target.nextElementSibling) {
        e.target.nextElementSibling.focus();
      }

      if (e.key === 'Escape') {
        this._onBlur();
      }
    }
  }, {
    key: "_onSelectResult",
    value: function _onSelectResult(value) {
      this._onBlur();

      this.props.onSelectResult(value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var shouldShowResults = this.state.hasFocus && !this.props.isLoading && this.props.children && this.props.children.length > 0 && this.props.value && this.props.value.length > 0;
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(e) {
          return _this3.container = e;
        },
        className: this._getClassName(),
        onFocus: this._onFocus,
        onBlur: this._onBlur,
        onKeyDown: this._onKeyDown
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_InputField["default"], _extends({}, this.props, {
        className: "rhe-typeahead__input",
        name: this.props.name,
        showLabel: !!this.props.label,
        placeholder: this.props.placeholder,
        value: this.props.value,
        required: this.props.required,
        disabled: this.props.disabled,
        autoComplete: "off",
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;
          return _this3.props.onChange(value);
        }
      }), this.props.label)), /*#__PURE__*/_react["default"].createElement(ResultsDialog, {
        show: this.props.isLoading
      }, /*#__PURE__*/_react["default"].createElement(_LoadingIndicator["default"], {
        show: this.props.isLoading
      })), /*#__PURE__*/_react["default"].createElement(ResultsDialog, {
        show: shouldShowResults
      }, this.props.children && this.props.children.map(function (child, index) {
        return _react["default"].cloneElement(child, {
          tabIndex: 0,
          key: index,
          onSelectResult: function onSelectResult() {
            return _this3._onSelectResult(child.props.value);
          }
        });
      })));
    }
  }]);

  return Typeahead;
}(_react["default"].Component);

exports["default"] = Typeahead;
Typeahead.defaultProps = {
  isLoading: false,
  onSelectResult: function onSelectResult() {},
  onChange: function onChange() {}
};
Typeahead.propTypes = {
  name: _propTypes["default"].string,
  label: _propTypes["default"].string,
  className: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  value: _propTypes["default"].string,
  onSelectResult: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  isLoading: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(["true", "false"])]),
  required: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(["true", "false"])]),
  disabled: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(["true", "false"])])
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/pattern-library/dist/js/components/Typeahead/index.js
// module id = 294
// module chunks = 0